let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kqC77")).then(() => parcelRequire('sqXDQ'));